import { SidebarItem } from "vue-sidebar-menu";
import { MenuGroup } from "./MenuGroup";

export class MenuItem implements SidebarItem {    
    constructor(title: string, url: string, claim: string, alias: string = null, child: Array<MenuGroup | MenuItem> = [], icon: string = null, disabled: boolean = false, OpenModal = false) {
        this.title = title;
        this.href = url;
        this.alias = alias;
        this.child = child;
        this.icon = icon;
        this.disabled = disabled
        this.Claim = claim;
        this.Active = false;
        this.OpenModal = OpenModal
    };
    
    public href: string;
    public title: string;
    public icon: string;
    public disabled: boolean;
    public child:  Array<MenuGroup | MenuItem>;
    public Claim: string;
    public Active: boolean;
    public OpenModal: boolean;
    public alias: string;


    //public PageTitle(): string {
    //    return (this.TitleLong == null) ? this.Title : this.TitleLong;
    //}
}